'use client';

import { useLocations, useUser } from '@/api';
import { useTranslation } from '@/app/_shared/hooks/useTranslation';
import type { Lang } from '@/app/_shared/i18n/types';
import { SelectionPage } from '@/components/common/SelectionPage';
import { toastService } from '@/components/common/Toaster';
import { useAuthContext } from '@/contexts/auth';

export default function SelectLocationsPage() {
	const { data: locations } = useLocations();
	const { user } = useAuthContext();
	const { updateProfile } = useUser();
	const { setLanguage } = useTranslation();
	const LANGUAGE_COUNTRY_MAP: Record<string, Lang> = {
		us: 'en',
		vn: 'vi',
		tr: 'tr',
		br: 'pt',
		id: 'id',
		in: 'hi',
		es: 'es',
	};
	const handleSave = (selected: string | string[]) => {
		updateProfile(
			{ locationCode: selected as string },
			{
				onSuccess: () => {
					setLanguage(LANGUAGE_COUNTRY_MAP[selected as string]);
					toastService.success('Location updated successfully');
					window.location.reload();
				},
			},
		);
	};

	return (
		<SelectionPage
			title="Locations"
			items={(locations?.data || []).map((location) => ({
				id: location.code,
				label: location.name,
				image: `https://flagcdn.com/${location.code}.svg`,
			}))}
			type="radio"
			onSave={handleSave}
			searchPlaceholder="Search Locations"
			initialSelected={user?.locationCode}
		/>
	);
}
